export const DEFAULT_REDIRECT_URL = '/app/';

export const CHATWOOT_RESET_PASSWORD_URL =
  'https://app.zetijuris.com.br/app/auth/reset/password';

export const DOCS_URL = 'https://app.zetijuris.com.br';
export const HELP_CENTER_URL = 'https://app.zetijuris.com.br';
export const TESTIMONIALS_URL = '';

export const STATUS_TYPE = {
  OPEN: 'open',
  RESOLVED: 'resolved',
  PENDING: 'pending',
  SNOOZED: 'snoozed',
  ALL: 'all',
};

export const SNOOZE_OPTIONS = {
  UNTIL_NEXT_REPLY: 'until_next_reply',
  AN_HOUR_FROM_NOW: 'an_hour_from_now',
  UNTIL_TOMORROW: 'until_tomorrow',
  UNTIL_NEXT_WEEK: 'until_next_week',
  UNTIL_NEXT_MONTH: 'until_next_month',
  UNTIL_CUSTOM_TIME: 'until_custom_time',
};

export const AVAILABILITY_STATUS_KEYS = ['online', 'busy', 'offline'];

export const CONVERSATION_TYPE = {
  ME: 'me',
  UNASSIGNED: 'unassigned',
  ALL: 'all',
};

export const ASSIGNEE_TYPE = {
  ME: 'me',
  UNASSIGNED: 'unassigned',
  ALL: 'all',
};

export const INBOX_SORT_BY = {
  NEWEST: 'latest',
  OLDEST: 'sort_on_created_at',
};

export const INBOX_DISPLAY_BY = {
  SNOOZED: 'snoozed',
  READ: 'read',
  ALL: 'all',
};

export const INBOX_FILTER_TYPE = {
  STATUS: 'status',
  TYPE: 'type',
  SORT_ORDER: 'sort_order',
};

export const SORT_BY_TYPE = {
  LATEST: 'latest',
  CREATED_AT: 'sort_on_created_at',
  PRIORITY: 'sort_on_priority',
  WAITING_SINCE: 'sort_on_waiting_since',
};

export const SMALL_SCREEN_BREAKPOINT = 768;
export const LARGE_SCREEN_BREAKPOINT = 1200;

export const LAYOUT_TYPES = {
  CONDENSED: 'condensed',
  EXPANDED: 'expanded',
};

export const ARTICLE_STATUS_TYPES = {
  DRAFT: 'draft',
  PUBLISHED: 'published',
  ARCHIVED: 'archived',
};

export const EXAMPLE_WEBHOOK_URL = 'https://example.com/webhook';

export const HELP_CENTER_DOCS_URL = 'https://app.zetijuris.com.br';

export default {
  DEFAULT_REDIRECT_URL,
  STATUS_TYPE,
  SNOOZE_OPTIONS,
  AVAILABILITY_STATUS_KEYS,
  CONVERSATION_TYPE,
  ASSIGNEE_TYPE,
  INBOX_SORT_BY,
  INBOX_DISPLAY_BY,
  INBOX_FILTER_TYPE,
  SORT_BY_TYPE,
  SMALL_SCREEN_BREAKPOINT,
  LARGE_SCREEN_BREAKPOINT,
  LAYOUT_TYPES,
  ARTICLE_STATUS_TYPES,
  EXAMPLE_WEBHOOK_URL,
  HELP_CENTER_DOCS_URL,
  DOCS_URL,
  HELP_CENTER_URL,
  TESTIMONIALS_URL,
  CHATWOOT_RESET_PASSWORD_URL,
};
